import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { ModifierControllerApi } from "../../services";
import { getConfigObject, useBaseContent } from "../../utils/utils";

interface UseGetModifiersProps {
  page?: number;
  size?: number;
  sortBy?: string;
  searchString?: string;
  sortDirection?: string;
  xTENANTID?: string;
}

/**
 * @author Atish Bagate
 */

const useGetModifiers = ({
  page,
  size,
  sortBy,
  searchString,
  sortDirection,
  xTENANTID,
}: UseGetModifiersProps): useBaseContent<any> => {
  return useQuery({
    queryKey: [
      "get-modifiers",
      page,
      size,
      sortBy,
      searchString,
      sortDirection,
      xTENANTID,
    ],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      new ModifierControllerApi(getConfigObject())
        .getAllModifiers(
          page ?? 0,
          size ?? 100,
          sortBy,
          searchString,
          sortDirection,
          xTENANTID
        )
        .then((res) => res?.data),
  });
};

export default useGetModifiers;
